import * as types from 'models/actionTypes'
import { RoomType } from './constants'

export const selectKioskRoomType = (roomType: RoomType) => ({
    type: types.SELECT_KIOSK_ROOM_TYPE,
    roomType,
})

export const setKioskIntroViewed = () => ({
    type: types.SET_KIOSK_INTRO_VIEWED,
})
